<template lang="pug">
  HomeClientView(v-if="user.role === 'client'")
  #home.custom-container(v-else)
    .section-title Hola {{user.name}}! Bienvenido/a de nuevo
    b-breadcrumb.breadcrumb(:items="breadcrumbs")
    CardResumenServices
    list-business-services
</template>
  
<script>
import { mapGetters } from 'vuex'
import ListBusinessServices from '../components/home/ListBusinessServices'
import CardResumenServices from '../components/home/CardResumenServices'
import HomeClientView from './HomeClientView'

export default {
  data(){
    return{
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { name: 'Home' }
        },
        {
          text: 'Vista mensual',
          active:true
        },
      ]
    }
  },
  components: {
    HomeClientView,
    ListBusinessServices,
    CardResumenServices
  },
  computed: {
    ...mapGetters('AuthenticationStore',['user']),
  }
};
</script>
